export default __webpack_public_path__ + "static/media/creditCardLogo.d7601e35.svg";